import { NgModule } from '@angular/core'
import { CartBaseCoreModule, CartPageEventModule } from '@spartacus/cart/base/core'
import { CartBaseOccModule } from '@spartacus/cart/base/occ'
import { CheckoutCoreModule } from '@spartacus/checkout/base/core'
import { CheckoutOccModule } from '@spartacus/checkout/base/occ'
import {
  AnonymousConsentsModule,
  AuthModule,
  CostCenterOccModule,
  ExternalRoutesModule,
  ProductModule,
  ProductOccModule,
  provideFeatureToggles,
  UserModule,
  UserOccModule
} from '@spartacus/core'
import {
  AnonymousConsentManagementBannerModule,
  AnonymousConsentsDialogModule,
  BannerCarouselModule,
  BannerModule,
  BreadcrumbModule,
  CategoryNavigationModule,
  CmsParagraphModule,
  ConsentManagementModule,
  FooterNavigationModule,
  HamburgerMenuModule,
  HomePageEventModule,
  LinkModule,
  LoginRouteModule,
  LogoutModule,
  NavigationEventModule,
  NavigationModule,
  NotificationPreferenceModule,
  PaymentMethodsModule,
  PDFModule,
  ProductCarouselModule,
  ProductDetailsPageModule,
  ProductIntroModule,
  ProductListingPageModule,
  ProductPageEventModule,
  ProductReferencesModule,
  ProductTabsModule,
  SearchBoxModule,
  SiteContextSelectorModule,
  TabParagraphContainerModule,
  VideoModule
} from '@spartacus/storefront'
import { AddressBookModule } from '@spartacus/user/profile/components'
import { ebFeatureToggles } from '../features/config/eb-feature-toggles'
import { AsmFeatureModule } from './features/asm/asm-feature.module'
import { CartBaseFeatureModule } from './features/cart/cart-base-feature.module'
import { CheckoutFeatureModule } from './features/checkout/checkout-feature.module'
import { OrderFeatureModule } from './features/order/order-feature.module'
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module'
import { UserFeatureModule } from './features/user/user-feature.module'

@NgModule({
  declarations: [],
  imports: [
    // Auth Core
    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,
    // Basic Cms Components
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    BreadcrumbModule,
    // User Core,
    UserModule,
    UserOccModule,
    // User UI,
    AddressBookModule,
    PaymentMethodsModule,
    NotificationPreferenceModule,
    ConsentManagementModule,
    // Anonymous Consents Core,
    AnonymousConsentsModule.forRoot(),
    // Anonymous Consents UI,
    AnonymousConsentsDialogModule,
    AnonymousConsentManagementBannerModule,
    // Product Core,
    ProductModule.forRoot(),
    ProductOccModule,
    // Product UI,
    ProductDetailsPageModule,
    ProductListingPageModule,
    SearchBoxModule,
    ProductTabsModule,
    ProductCarouselModule,
    ProductReferencesModule,
    ProductIntroModule,
    // Cart Core,
    CartBaseCoreModule,
    CartBaseOccModule,
    CartBaseFeatureModule,
    // Checkout Core,
    CheckoutCoreModule,
    CheckoutOccModule,
    CostCenterOccModule,
    // Page Events,
    NavigationEventModule,
    HomePageEventModule,
    CartPageEventModule,
    ProductPageEventModule,
    UserFeatureModule,
    SmartEditFeatureModule,
    ProductDetailsPageModule,
    ProductListingPageModule,
    ExternalRoutesModule.forRoot(),
    AnonymousConsentsDialogModule,
    AsmFeatureModule,
    UserOccModule,
    CheckoutFeatureModule,
    OrderFeatureModule,
    VideoModule,
    PDFModule
  ],
  providers: [provideFeatureToggles(ebFeatureToggles)]
})
export class SpartacusFeaturesModule {}
